import React from "react";
import RecentEvents from "../components/RecentEvents";
import UpcomingEvents from "../components/UpcomingEvents";
import MissionVision from "../components/MissionVision";
import AdmissionBanner from "../components/AchievementShowcase";
import SEOHead from "../components/SEOHead";
import { Link } from "react-router-dom";
import PeopleCount from "../components/PeopleCount";

export default function Home() {
	return (
		<>
			<SEOHead
				title="Sacred Heart School Chumoukedima - Quality Education from Nursery to Class 8"
				description="Looking for a good school in Chumoukedima? Sacred Heart School offers quality education with experienced teachers, modern facilities, and FREE admission for Nursery & LKG. 100% HSLC pass rate!"
				keywords="school in chumoukedima, best school dimapur, sacred heart school, admission nursery lkg, free admission, quality education nagaland, experienced teachers, good school near me"
				canonicalUrl="https://sacredheartchumoukedima.com/"
				ogTitle="Sacred Heart School - Where Every Child Matters"
				ogDescription="Quality education in Chumoukedima with FREE admission for Nursery & LKG. Modern facilities, caring teachers, and proven results."
				ogImage="https://sacredheartchumoukedima.com/logo.png"
			/>
			<div className="relative bg-black">
				<img
					className="w-full object-cover h-[90dvh] z-0 hover:z-50 "
					src="/assets/images/slide1.jpg"
					alt=""
					style={{ opacity: "0.5" }}
				/>
				<div
					className="absolute text-white  w-full text-center "
					style={{
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						textShadow: "2px 2px 10px rgba(0, 0, 0, 0.7)",
					}}
				>
					<h1 className="text-4xl md:text-7xl mb-7">
						Welcome to Sacred Heart School
					</h1>
					<h1 className="text-1xl md:text-4xl mb-7">
						Where Education Meets Excellence
					</h1>
					<Link to="/admission">
						<div className="flex justify-center">
							<div className="group relative cursor-pointer p-2 w-32 border bg-white rounded-full overflow-hidden text-black text-center font-semibold">
								<span className="translate-y-0 group-hover:-translate-y-12 group-hover:opacity-0 transition-all duration-300 inline-block">
									Enroll Now
								</span>
								<div className="flex gap-2 text-white bg-green-400 z-10 items-center absolute left-0 top-0 h-full w-full justify-center translate-y-12 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 rounded-full group-hover:rounded-none ">
									<span>Enroll Now</span>
								</div>
							</div>
						</div>
					</Link>
				</div>
			</div>
			<AdmissionBanner />
			<PeopleCount />
			<RecentEvents />
			{/* <UpcomingEvents /> */}
			<MissionVision />
		</>
	);
}
